import axios from "axios";
const BaseURL = process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT;
//tocheck url
function isSafe(dangerousURL) {
  const url = new URL(dangerousURL);
  return !(url.protocol === "javascript:" || url.protocol === "");
}
export const clearLoginSession = async (body) => {
  axios.defaults.withCredentials = true;
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/login/clearLoginSession",
    body
  );
  return res.data || [];
};

export const UpdateBusinessAnalsys = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  // const url=`${BaseURL}/analysis/update`;
  try{
    
      // let res = await axios.put(
      //   url,
      //   data
      // );
      return  [];
    }catch (error) {
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
// export const deletePlanRequest = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/manager/deletePlanRequest",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const deleteWorkProgramRequest = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/manager/deleteWorkProgramRequest",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const deleteRiskRequestByID = async (riskID) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskAssessment/deleteRiskRequest`,
//     {
//       params: {
//         userId: riskID,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
  //Request failed with status code 401 Error
  // if (error.message === "Request failed with status code 401") {
  //   await clearLoginSession({ userID: userID });
  //   sessionStorage.removeItem("jwtToken");
  //   window.location.href = process.env.REACT_APP_FRONTEND_URL;
  // }
// }
// };

// export const resetNewPasswordEmailValidation = async (body) => {
//   axios.defaults.withCredentials = true;
  
//     let res = await axios.post(
//       process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//         "/login/resetNewPasswordEmailValidation",
//       body
//     );
//     return res.data || [];
  

 
// };
// export const loginValidate = async (payload) => {
//   axios.defaults.withCredentials = true;
//   let { data } = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/login",
//     payload
//   );
//   return data;
// };
// export const loginValidateOTP = async (payload) => {
//   axios.defaults.withCredentials = true;
//   let { data } = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/login/validateotplogin",
//     payload
//   );
//   return data;
// };
// export const resetPassword = async (body) => {
//   axios.defaults.withCredentials = true;
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/login/sendLinkForPasswordReset",
//     body
//   );
//   return res.data || [];
// };
// export const resetNewPassword = async (body) => {
//   axios.defaults.withCredentials = true;
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/login/resetNewPassword",
//     body
//   );
//   return res.data || [];
// };

// ---------add vendor-------
// export const vendorRegistration = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/vendor/create",
//     data
//   );
//   return res.data || [];
//   }catch (error) {
//     console.log("Error",error)
//     //Request failed with status code 401 Error
//     if (error.message === "Request failed with status code 401") {
//       await clearLoginSession({ userID: userID });
//       sessionStorage.removeItem("jwtToken");
//       window.location.href = process.env.REACT_APP_FRONTEND_URL;
//     }
//   }
// };

// export const provideVendorResponse = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/vendor/provideVendorResponse",
//     data
//   );
//   return res.data || [];
//   }catch (error) {
//     console.log("Error",error)
//     //Request failed with status code 401 Error
//     if (error.message === "Request failed with status code 401") {
//       await clearLoginSession({ userID: userID });
//       sessionStorage.removeItem("jwtToken");
//       window.location.href = process.env.REACT_APP_FRONTEND_URL;
//     }
//   }
// };
// ----------getvendordata----------
// export const getAllVendorList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/vendor"
//   );
//   return res.data || [];
//   }catch (error) {
//     console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getriskvendorlist = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/vendor/getRiskVendorList"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------getvendordata----------
// export const getAllAssessmentVendorList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/vendor/existvendors"
//   );
//   return res.data || [];
//  }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------getbusinessunitlist----------
// export const getAllBusinessUnitList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/vendor/getAllBusinessUnitList"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------getsubbusinessunitlist----------
// export const getAllSubBusinessUnitList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/vendor/getAllSubBusinessUnitList"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// --------------soft delete vendors----------
// export const deleteVendorRecord = async (vendorId, vendorUserId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/vendor/deletevendorrecord`,
//     {
//       params: {
//         ID: vendorId,
//         VID: vendorUserId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: vendorUserId });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// --------------update vendor record by id----------
// export const updateRecordById = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/vendor/updatevendorrecord/",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------get vendor data by id----------
// export const getVendorRecordsById = async (vendorId, vendorUserId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + `/vendor/vendorId`,
//     {
//       params: {
//         ID: vendorId,
//         VID: vendorUserId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: vendorUserId });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ---------add User-------
// export const userRegistration = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/user/create",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const businessRegistration = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/analysis/create",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------getbusinessdata----------
// export const getAllAnalysisList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{

//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/analysis"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// --------------soft delete business----------
// export const deleteBusinessAnalysisRecord = async (id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + `/analysis/delete`,
//     {
//       params: {
//         ID: id,
//       },
//     }
//   );
//   return res.data || [];
//   }catch (error) {
//     console.log("Error",error)
//     //Request failed with status code 401 Error
//     if (error.message === "Request failed with status code 401") {
//       await clearLoginSession({ userID: userID });
//       sessionStorage.removeItem("jwtToken");
//       window.location.href = process.env.REACT_APP_FRONTEND_URL;
//     }
//   }
// };
// --------------update business record by id----------


// ----------getUserdata----------
// export const getAllUserList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/user"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)                               
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// --------------soft delete users----------
// export const deleteUserRecord = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + `/user/deleteuserrecord`,
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------get business data by id----------
// export const GetBusinessAnalysisById = async (id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + `/analysis`,
//     {
//       params: {
//         ID: id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------get user data by id----------
// export const getUserRecordsById = async (orgid, roleid) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + `/user/getuser`,
//     {
//       params: {
//         Org: orgid,
//         Role: roleid,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------getRoles----------
// export const getRoles = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/user/getuserroles"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// -------------getalluserslist------------------
// export const getUserList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/user/getuserslist"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const FetchOrgRoles = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/organization/ReadAllRoles"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------getRoles----------
// export const fetchAllOrganizations = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/organization"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const addNewOrganization = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/organization/create",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const editOrganization = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/organization/EditOrganization",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const AddrolesToOrganization = async (body) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/organization/AddRole",
//     body
//   );
//   return res.data;
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const deleteOrganization = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/organization/DeleteOrganization",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const DeleteRoles = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/organization/Deleteroles",
//     body
//   );
//   return res.data || [];
  
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const EditrolesToOrganization = async (body) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/organization/EditRole",
//     body
//   );
//   return res.data;
  
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ----------get existing roles by org id----------
// export const getExistRolesById = async (orgId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/organization/ReadRolesById`,
//     {
//       params: {
//         ID: orgId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getOrgDetailsById = async (orgId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/organization/orgDetailsById`,
//     {
//       params: {
//         ID: orgId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// ---------Organization-addusers----------
// export const assignUsers = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/organization/AddUsers",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// ---------Vendor-Routes----------
// export const fetchSelfAssessmentList = async (userId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getSelfAssessments`
//   );
//   return res.data || [];
  
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userId });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getWorkprogramCategoryData = async (userId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getWorkprogramCategory`,
//     {
//       params: {
//         ID: userId,
//       },
//     }
//   );
//   return res.data || [];
  
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userId });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const fetchUpdateSelfAssessmentList = async (userId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getUpdateSelfAssessments`,
//     {
//       params: {
//         ID: userId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userId });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getSelfAssessmentById = async (id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getSelfAssessmentDetails`,
//     {
//       params: {
//         ID: id,
//       },
//     }
//   );
//   return res.data || [];
  
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getUpdatedSelfAssessmentByID = async (id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getUpdateSelfAssessmentDetails`,
//     {
//       params: {
//         Id: id,
//       },
//     }
//   );
//   return res.data || [];
  
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getConductedAssessmentData = async (WPId,ASMId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getConductedAssessment`,
//     {
//       params: {
//         ID1:WPId ,
//         ID2:ASMId
//       },
//     }
//   );
//   return res.data || [];
  
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAssessmentByWPID = async (id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getAssessmentDetailsByWPID`,
//     {
//       params: {
//         wpId: id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const updateSelfAssessment = async (data) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/updateSelfAssessmentData`,
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const deleteSelfAssessment = async (id) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/deleteSelfAssessment`,
//     {
//       params: {
//         ID: id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// --------- Analyst Routes----------
// export const getAllTPRequests = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/analyst/getAllTPRequest"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAnalystWorkPrograms = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/analyst/getWorkprograms"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAssessmentList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/analyst/getAssessmentList"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getRiskChangeRequest = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/analyst/getChangeRequest"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getIssueClosures = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/analyst/viewIssues"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getTPRequestById = async (Id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/analyst/getThirdPartyRequestById`,
//     {
//       params: {
//         Id: Id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getWorkProgramDetailsById = async (Id, vendorid) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/analyst/getWorkProgramDetailsById`,
//     {
//       params: {
//         ID: Id,
//         vendorid: vendorid
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const createWorkProgram = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/analyst/createProgram",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getExcelTableDate = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/analyst/getExcelTableDate",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const createAssessment = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/analyst/createPlan",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const updateRiskChangeRequest = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
// let userID = sessionStorage.getItem("userId");
// try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/analyst/updateChangeRequest/",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const ApproveIssues = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  
// let userID = sessionStorage.getItem("userId");
// try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/analyst/approveIssue/",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const deleteTPRequest = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/analyst/deleteTPRequest`,
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const deleteAssessmentPlan = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/analyst/deleteAssessmentPlan`,
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------file upload------------
// export const addFile = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/analyst/addFile",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const saveEvidence = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/controlAssessment/saveEvidence",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAllFiles = async (type) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + `/analyst/getAllFiles`,
//     {
//       params: {
//         id: type,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// --------- BU Routes----------

// export const createNewTPRequest = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/businessUser/createTPRequest",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getTPDataById = async (Id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/businessUser/getTPDataById`,
//     {
//       params: {
//         ID: Id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const updateTPRequest = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/businessUser/updateTPRequest",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAllQuestionsList = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/businessUser/getAllQuestionsList",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const reviewTPRequest = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/businessUser/reviewTPRequest",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const deleteTPRequestData = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/businessUser/deleteTPDataRequest`,
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getSelectedVendorAddress = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/businessUser/getSelectedVendorAddress`,
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getTPListDetails = async (Id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  
// let userID = sessionStorage.getItem("userId");
// try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/businessUser/getTPListDetails`,
//     {
//       params: {
//         thirdPartyId: Id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getTPContactInfo = async (Id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
// let userID = sessionStorage.getItem("userId");
// try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/businessUser/getTPContactInfo`,
//     {
//       params: {
//         tPUserId: Id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getSelectedThirdPartyDetails = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/businessUser/getSelectedThirdPartyDetails"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//-------------------------Manager----------------------
// export const getVendorRequests = async (orgId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/manager/getVendorRequests`,
//     {
//       params: {
//         orgId: orgId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const selectVendorRequests = async (orgId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/manager/selectVendorRequests`,
//     {
//       params: {
//         orgId: orgId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getPlanRequests = async (orgId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/manager/getPlanRequests`,
//     {
//       params: {
//         orgId: orgId,
//         userID: userID
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const selectPlanRequests = async (orgId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/manager/selectPlanRequests`,
//     {
//       params: {
//         orgId: orgId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getWorkPrograms = async (orgId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/manager/getWorkPrograms`,
//     {
//       params: {
//         orgId: orgId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const selectWorkPrograms = async (orgId, vendorid) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/manager/selectWorkPrograms`,
//     {
//       params: {
//         orgId: orgId,
//         vendorid: vendorid
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };


// export const updatedAssessment = async (asmId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/manager/updatedAssessmentData`,
//     {
//       params: {
//         asmID: asmId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const updateVendorRequest = async (body) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/manager/updateVendorRequest",
//     body
//   );
//   return res.data;
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const updatePlanRequest = async (body) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/manager/updatePlanRequest",
//     body
//   );
//   return res.data;
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const updateWorkProgramRequest = async (body) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/manager/updateWorkProgramRequest",
//     body
//   );
//   return res.data;
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const deleteVendorRequest = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/manager/deleteVendorRequest",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

//-------------------------Manager----------------------

//----------Assessor-----------------------------------

// export const getSelfAssessments = async (userId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getSelfAssessmentsforAssessor`,
//     {
//       params: {
//         userId: userId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getSelectedSelfAssessment = async (id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getSelectedSelfAssessment`,
//     {
//       params: {
//         ID: id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getOnSiteAssessments = async (userID) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getOnSiteAssessments`,
//     {
//       params: {
//         userId: userID,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getApproveSelfAssessments = async (userId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getApproveSelfAssessments`,
//     {
//       params: {
//         userId: userId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getInitiatedOnsiteAssessments = async (id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getInitiatedOnsites`,
//     {
//       params: {
//         ID: id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getSelectedOnSiteAssessment = async (id) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/getSelectedOnSiteAssessment`,
//     {
//       params: {
//         ID: id,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const initiateSelfAssessment = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/controlAssessment/initiateSelfAssessment",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const approveSelfAssessment = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/controlAssessment/approveSelfAssessment",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const initiateOnsiteAssessment = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/controlAssessment/initiateOnsiteAssessment",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const updateSelectedSelfAssessment = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/controlAssessment/updateSelectedSelfAssessment",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const DeleteSelectedSelfAssessment = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/controlAssessment/DeleteSelectedSelfAssessment",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const updateSelectedOnSiteAssessment = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/controlAssessment/updateSelectedOnSiteAssessment",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const DeleteSelectedOnSiteAssessment = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/controlAssessment/DeleteSelectedOnSiteAssessment",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//-----------------------common------------------------

// export const getStatus = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/common/getStatus"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAllBUUsersList = async (orgId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/common/getAllBUUsersList`,
//     {
//       params: {
//         ID: orgId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getAllPriorityLevels = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/common/getAllPriorityLevels"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getCriticalityList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/common/getCriticalityList"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getVendors = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/common/getVendors"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getCategoryList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/common/getCategoryList"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getManagerEmails = async (ID) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/common/getManagerEmail`,
//     {
//       params: {
//         ID: ID,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAssessorEmails = async (ID) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/common/getAssessorEmail`,
//     {
//       params: {
//         ID: ID,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getProfileDataByUserId = async (ID) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/common/getProfileData",
//     ID
    
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAllBUAssessmentTypeList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/common/getAllBUAssessmentTypeList"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAllBUFrequencyList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/common/getAllBUFrequencyList"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAllBURecurrenceList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/common/getAllBURecurrenceList"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAllManagersList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/common/getManagers"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAllAssessorsList = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/common/getAssessors"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getAllClassifications = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/common/getClassifications"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

//-----------------------common------------------------
//***********Risk Assessment api services start******
// ---------create risk request-------
// export const createRiskRequest = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.post(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/riskAssessment/create",
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//-----------------get Business Impact Analysis----------
// export const getBusinessImpactAnalysis = async (userId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskAssessment/getBusinessImpactAnalysis`,
//     {
//       params: {
//         userId: userId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getBIAReviewData = async (userId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskAssessment/getBIAReviewData`,
//     {
//       params: {
//         userId: userId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getAllRiskData = async (userId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskAssessment/getAllRiskData`,
//     {
//       params: {
//         userId: userId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------get Business Impact Analysis By ID---------------
// export const getBusinessImpactByID = async (riskID) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   let roleID = sessionStorage.getItem("roleId")
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskAssessment/getBusinessImpactByID`,
//     {
//       params: {
//         userId: riskID,
//         roleID: roleID
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------update Selected Business Impact------------
// export const updateSelectedBusinessImpact = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/riskAssessment/editBusinessImpact",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const updateRiskRequest = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/riskAssessment/editRik",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------Review Selected Business Impact------------
// export const reviewSelectedBusinessImpact = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/riskAssessment/reviewBusinessImpact",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

//-----------------get Risk Request Data----------
// export const getRiskRequestData = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/riskAssessment/getRiskRequest"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//-----------------delete Risk Request record by id----------

//***********Risk Tracking api services start******
//-----------------get ManageRisk Data----------
// export const getManageRiskData = async (userId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskTracking/getManageRiskData`,
//     {
//       params: {
//         ID: userId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------get Business Impact Analysis By ID---------------
// export const getManageRiskById = async (riskID) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskTracking/getManageRiskById`,
//     {
//       params: {
//         ID: riskID,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getAssessmentRiskById = async (thirdPartyId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskTracking/getAssessmentRiskById`,
//     {
//       params: {
//         ID: thirdPartyId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
// export const getRiskDataById = async (thirdPartyId) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskTracking/getRiskDataById`,
//     {
//       params: {
//         ID: thirdPartyId,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------update Selected Business Impact------------
// export const updateManageRiskById = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/riskTracking/editManageRiskById",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//-----------------get ManageRisk Data----------
// export const getChangeRequestsRiskData = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/riskTracking/getChangeRequestsRiskData"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------get ChangeRequests Risk ByID---------------
// export const getChangeRequestsRiskByID = async (riskID) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskTracking/getChangeRequestsRiskByID`,
//     {
//       params: {
//         ID: riskID,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------update Selected Business Impact------------
// export const updateRiskRequestById = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/riskTracking/editRiskRequestById",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//-----------------get Risk Change Request Data----------
// export const getRiskChangeRequestData = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/riskTracking/getRiskChangeRequestData"
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------get Risk Change Request ByID---------------
// export const getRiskChangeRequestByID = async (riskID) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/riskTracking/getRiskChangeRequestByID`,
//     {
//       params: {
//         ID: riskID,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
//----------------update Risk Approval ById------------
// export const updateRiskApprovalById = async (body) => {
//   axios.defaults.withCredentials = true;
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       "/riskTracking/editRiskApprovalById",
//     body
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// /-----------------------DashBoards----------------------

// export const getThirdPartiesCount = async () => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/dashboard/getThirdPartiesCount`
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

// export const getExistedGraphsData = async (ID) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.get(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/dashboard/getExistedGraphs`,
//     {
//       params: {
//         id: ID,
//       },
//     }
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };

export const dragAndDropInsert = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/dashboard/dragAndDropInsert",
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getOptionalWidgetsData = async (ID) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getOptionalWidgets`,
      {
        params:{
          userID:ID,
        }
      }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getOverAllRiskTrendsCount = async (country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getOverAllRiskTrendsCount`,
    {
      params: {
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const RatingbyRiskchartCount = async (country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getRatingbyRiskchartCount`,
    {
      params: {
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const UpcomingAssessmentsChartCount = async (country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/UpcomingAssessmentsChartCount`,
    {
      params: {
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const RiskagingDrilldown = async (ID, country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/riskAgingDrilldown`,
    {
      params: {
        month: ID,
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const IssueagingDrilldown = async (ID, country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/issueAgingDrilldown`,
    {
      params: {
        month: ID,
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const UpcomingAssessmentsDrilldown = async (month, country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/upcomingAssessmentDrilldown`,
    {
      params: {
        month: month,
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const RatingByRiskDrilldown = async (ID, value, country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/ratingByRiskDrilldown`,
    {
      params: {
        month: ID,
        values: value,
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const issueByRatingDrilldown = async (ID, country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/issueByRatingDrilldown`,
    {
      params: {
        issueID: ID,
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const CriticalRatingDrilldown = async (ID, country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/criticalRatingDrilldown`,
    {
      params: {
        ID: ID,
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const RiskOverallTrendDrilldown = async (ID, time, country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/riskOverallTrendDrilldown`,
    {
      params: {
        ID: ID,
        timeStamp: time,
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getActiveAssessmentCount = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getActiveAssessmentCount`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getOverdueAssessmentCount = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getOverdueAssessmentCount`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getActiveIssuesCount = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getActiveIssuesCount`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getActiveRisksCount = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getActiveRisksCount`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getAssessmentTableList = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getAssessmentTableList`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getPriorityLevelData = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getPriorityLevelData`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getRegionalRiskScore = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getRegionalRiskScore`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getOverallRiskScore = async (country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getOverallRiskScore`,{
        params: {
          country: country,
        },
      }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getOverallRiskTrend = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getOverallRiskTrend`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getThirdPartyCriticalityRating = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getThirdPartyCriticalityRating`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getIssuesbyRating = async (country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getIssuesbyRating`,
    {
      params: {
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getIssuesbyRatingDrill = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getIssuesbyRatingDrill`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getIssueAgingChart = async (country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getIssueAgingChart`,
    {
      params: {
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getRiskAgingChart = async (country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getRiskAgingChart`,
    {
      params: {
        country: country,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getWidgetsData = async (country) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getWidgetsData`,
      {
        params: {
          country: country,
        },
      }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getSelectedGraphs = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getSelectedGraphs`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getPeriodicAssessmentChart = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getPeriodicAssessmentChart`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getRatingbyRisksChart = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getRatingbyRisksChart`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getIssuesbyPriorityChart = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getIssuesbyPriorityChart`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getIssueAgingReport = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getIssueAgingReport`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getTopTenVendorsByRiskRating = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getTopTenVendorsByRiskRating`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getAllDashboardGraphsList = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getAllDashboardGraphsList`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const updateDashboardGraphFlag = async () => {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.put(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/dashboard/updateDashboardGraphFlag"
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getThirdPartyCriticalityRatingCount = async (countryCode) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/dashboard/getThirdPartyCriticalityRatingCount`,
    {
      params: {
        countryCode: countryCode,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

// /-----------------------DashBoards----------------------
//***********Issue Management api services start******
// ---------create issue request-------
export const createIssueRequest = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/issues/createIssue",
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getAssessmentData = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/issues/getAssessmentData",
    {
      params: {
        data: data,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getAllAnalystData = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/issues/getAllAnalyst",
    {
      params: {
        data: data,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
//All Issues
export const getAllViewIssues = async (userId) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/issues/getAllViewIssues`,
    {
      params: {
        userId: userId,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
//All View Update Requests
export const getViewUpdateRequests = async (userId) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/issues/getViewUpdateRequests`,
    {
      params: {
        userId: userId,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
//All View Action Requests
export const getViewActionRequests = async (userId) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/issues/getViewActionRequests`,
    {
      params: {
        userId: userId,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getAllVendorViewIssues = async (userId) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/issues/getAllVendorViewIssues`,
    {
      params: {
        userId: userId,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getManageIssuesRequests = async (userId) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/issues/getManageIssuesRequests`,
    {
      params: {
        userId: userId,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getCloseIssuesRequests = async (userId) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/issues/getCloseIssuesRequests`,
    {
      params: {
        userId: userId,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getViewAllIssues = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/issues/getViewAllIssues/"
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getIssueById = async (issueID) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + `/issues/getIssueById`,
    {
      params: {
        issueID: issueID,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const requestViewIssue = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/issues/requestViewIssue",
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const manageViewIssue = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/issues/editManageIssue",
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const closeViewIssue = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/issues/editRequestClosure",
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
// -----------------vendor issue management----------

//-----------------master Repository----------
export const getmasterWorkPrograms = async (orgId) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/common/getmsWorkPrograms/`,
    {
      params: {
        orgId: orgId,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const createmasterWorkProgram = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/common/createmasterProgram",
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const updateViewIssues = async (body) => {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.put(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/issues/updateIssues",
    body
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const deleteIssueRequestByID = async (issueID) => {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.put(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/issues/deleteIssueRequest/${issueID}`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const approvalViewIssue = async (body) => {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.put(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/issues/approveAnalystIssues",
    body
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

// -----------------Push Notifcations----------

export const addNotifcations = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/notifcation/postNotifcations",
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
//-----------------master Repository----------
export const createCtrlWorkProgram = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/masterRepository/createCtrlWorkProgram",
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getAllControlWorkProgram = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/masterRepository/getAllControlWorkProgram"
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getCtrlWorkProgramById = async (wpID) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/masterRepository/getCtrlWorkProgramById`,
    {
      params: {
        wpID: wpID,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const updateCtrlWorkProgram = async (body) => {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.put(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/masterRepository/editCtrlWorkProgram",
    body
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const deleteCtrlWorkProgramById = async (wpID) => {
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.put(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/masterRepository/deleteCtrlWorkProgram`,
    {
      params: {
        wpID: wpID,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};
export const getAllCtrlWPCategoryList = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId")
  try {
    let res = await axios.get(
      process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
        "/masterRepository/getAllWPCategoryList"
    );
    return res.data || [];
  } catch (error) {
    console.log("Error",error)
    //Request failed with status code 401 Error
    if (error.message === "Request failed with status code 401") {
      await clearLoginSession({ userID: userID });
      sessionStorage.removeItem("jwtToken");
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
  }
};
export const getNotifcationsCount = async (roleID, userID) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  axios.defaults.headers.common["roleid"] = sessionStorage.getItem("roleId");
  axios.defaults.headers.common["userid"] = sessionStorage.getItem("userId");
  try {
    let res = await axios.get(
      process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
        `/notifcation/getNotifcationsCount`,
      {
        params: {
          roleID: roleID,
          userID: userID,
        },
      }
    );
    return res.data || [];
  } catch (error) {
    console.log("Error",error)
    //Request failed with status code 401 Error
    if (error.message === "Request failed with status code 401") {
      await clearLoginSession({ userID: userID });
      sessionStorage.removeItem("jwtToken");
      window.location.href = process.env.REACT_APP_FRONTEND_URL;
    }
  }
};

export const getNotifcationsByRoleID = async (roleID, userID) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/notifcation/getNotifcationsByRoleID`,
    {
      params: {
        roleID: roleID,
        userID: userID,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getAuditsByRoleID = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/auditHistory/getAuditHistory`
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getEmailsByRoleID = async (ID) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/common/getEmailByRoleId`,
    {
      params: {
        ID: ID,
      },
    }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const idamSuccess = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      `/login/idamSuccess/jwtKey?code=${data.code}`,
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const IdamLoginManager = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
      "/login/IdamLoginManager",
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const getAssessmentUnitUserList = async () => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + "/clientadmin/userlist"
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

export const verifyIdamLogin = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  let userID = sessionStorage.getItem("userId");
  try{
  let res = await axios.post(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + `/login/verifyIdamLogin`,
    data
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    await clearLoginSession({ userID: userID });
    sessionStorage.removeItem("jwtToken");
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }
}
};

// ----------get file download id----------
export const downloadFile = async (data) => {
  axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
  try{
  let res = await axios.get(
    process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT + `/controlAssessment/downloadEvidence`,
    {
      params: {
        FileName: data,
      },
      responseType: 'blob'   
     }
  );
  return res.data || [];
}catch (error) {
  console.log("Error",error)
  //Request failed with status code 401 Error
  if (error.message === "Request failed with status code 401") {
    console.log("Error",error)

  }
}
};

// export const deleteAssessmentPlanByAssessor = async (data) => {
//   axios.defaults.headers.common["jwtAuth"] = sessionStorage.getItem("jwtToken");
//   let userID = sessionStorage.getItem("userId");
//   try{
//   let res = await axios.put(
//     process.env.REACT_APP_TPRM_BACK_END_SERVICE_PORT +
//       `/controlAssessment/DeleteSelfAssessment`,
//     data
//   );
//   return res.data || [];
// }catch (error) {
//   console.log("Error",error)
//   //Request failed with status code 401 Error
//   if (error.message === "Request failed with status code 401") {
//     await clearLoginSession({ userID: userID });
//     sessionStorage.removeItem("jwtToken");
//     window.location.href = process.env.REACT_APP_FRONTEND_URL;
//   }
// }
// };
